import { Link } from "react-router-dom";

const linkPattern = /\[\[([^\]|]+)\|([^\]]+)\]\]/g;

interface LinkedTextProps {
  text: string;
  className?: string;
}

export const LinkedText = ({ text, className }: LinkedTextProps) => {
  if (!text.includes("[[")) {
    return <span className={className}>{text}</span>;
  }

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = linkPattern.exec(text)) !== null) {
    const [fullMatch, slug, label] = match;
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(
      <Link
        key={match.index}
        to={`/team/${slug.trim()}`}
        className="text-primary underline underline-offset-2 hover:text-foreground transition-colors"
      >
        {label.trim()}
      </Link>
    );
    lastIndex = match.index + fullMatch.length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <span className={className}>{parts}</span>;
};

export default LinkedText;
